export default __webpack_public_path__ + "static/media/769.b3c987fa.png";